import { isNull } from 'lodash-es'

const VALIDATION_THRESHOLD_MS = 1000 * 60 * 10 // 10분

export const validateSignUpComplete = ({
  verificationType,
  signUpCompleteTime,
}: {
  verificationType: 'phone' | 'passport' | null
  signUpCompleteTime: string
}) => {
  const isVerificationTypeValid = !isNull(verificationType)

  const isRecentlyCompleted =
    new Date().getTime() - new Date(signUpCompleteTime).getTime() <
    VALIDATION_THRESHOLD_MS

  return isVerificationTypeValid && isRecentlyCompleted
}
